/**
 * Governance Service
 * AIDLC Administrative Backend
 *
 * API calls for governance rules and compliance operations.
 * Interface matches the backend GovernanceItem schema.
 */

import apiClient from './api';

export interface GovernanceRule {
  id: string;
  name: string;
  description: string;
  type: string;
  config: Record<string, unknown>;
  appliesTo: string[];
  isActive: boolean;
  priority: number;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

const GOVERNANCE_PATH = '/governance';

export async function getGovernanceRules(): Promise<GovernanceRule[]> {
  const response = await apiClient.get<GovernanceRule[]>(`${GOVERNANCE_PATH}/rules`);
  return response.data;
}

export async function createGovernanceRule(
  rule: Omit<GovernanceRule, 'id' | 'createdAt' | 'updatedAt'>
): Promise<GovernanceRule> {
  const response = await apiClient.post<GovernanceRule>(`${GOVERNANCE_PATH}/rules`, rule);
  return response.data;
}

export async function updateGovernanceRule(
  ruleId: string,
  updates: Partial<GovernanceRule>
): Promise<GovernanceRule> {
  const response = await apiClient.put<GovernanceRule>(
    `${GOVERNANCE_PATH}/rules/${ruleId}`,
    updates
  );
  return response.data;
}
